const customStyle = (width, height) => {
  const style = {};
  if (width) {
    style.width = `${width}px`;
  }
  if (height) {
    style.height = `${height}px`;
  }
  return style;
};

export default customStyle;
